var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"ball",style:('color:' + _vm.color)})
}
var staticRenderFns = []

export { render, staticRenderFns }